package util

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf

// On the web the app is loaded over the network, so treat it as online. (The start screen uses this
// only to gate the offline toggle, which isn't relevant on web.)
actual fun networkAvailableFlow(): Flow<Boolean> = flowOf(true)
